import { axios } from '@Root/API'

export const getStatuses = () => {
	return axios.get('status-list')
}
